import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { DisplayIconFactory } from './display-icon-factory.interface';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class WashFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        return {
            getLabelText: () => item.displayValue || item.name,
            materialIcon: 'water_drop',
            isLabelVisible: () => true,
            getValue: () => item.value,
            conditionalCls: [
                {
                    cls: 'wash-sensor-on',
                    condition: () => !!item.actualValue
                },
                {
                    cls: 'material-icons-outlined',
                    condition: () => !item.actualValue
                }
            ]
        };
    }
}
